export const GET_TESTIMONIAL = "GET_TESTIMONIAL";
export const GET_TESTIMONIAL_SUCCESS = "GET_TESTIMONIAL_SUCCESS";
export const GET_TESTIMONIAL_ERROR = "GET_TESTIMONIAL_ERROR";